import React, { useState, useEffect } from 'react';
import { Header } from './components/Header';
import { MenuCategory } from './components/MenuCategory';
import { CategoryNavigation } from './components/CategoryNavigation';

import { WelcomeScreen } from './components/WelcomeScreen';
import { AdminPanel } from './components/AdminPanel';
import { GlobalStyles, Container } from './styles/GlobalStyles';
import { restaurantData } from './data/menuData';
import { getPrices, subscribePrices, savePrices } from './services/pricingStore';

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  const [showAdmin, setShowAdmin] = useState(false);
  const [activeCategory, setActiveCategory] = useState(restaurantData.categories[0]?.id);
  const [menuData, setMenuData] = useState(restaurantData);
  const [suppressSpyUntil, setSuppressSpyUntil] = useState(0);
  


  // Global fiyatları yükle ve değişikliklere abone ol
  useEffect(() => {
    let unsubscribe = null;
    (async () => {
      const prices = await getPrices();
      if (prices && Object.keys(prices).length > 0) {
        updateMenuPrices(prices);
      }
      unsubscribe = await subscribePrices((latest) => {
        if (latest && Object.keys(latest).length > 0) {
          updateMenuPrices(latest);
        }
      });
    })();
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Admin panel için URL kontrolü
  useEffect(() => {
    const path = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    
    // /admin URL'i veya ?admin=true parametresi
    if (path === '/admin' || urlParams.get('admin') === 'true') {
      setShowAdmin(true);
      setShowWelcome(false); // Welcome screen'i atla
    }
  }, []);

  // Fiyatları güncelleme fonksiyonu
  const updateMenuPrices = (priceUpdates) => {
    const updatedMenuData = {
      ...menuData,
      categories: menuData.categories.map(category => ({
        ...category,
        items: category.items.map(item => ({
          ...item,
          price: priceUpdates[item.id] ?? item.price
        }))
      }))
    };
    setMenuData(updatedMenuData);
  };

  // Admin panel fiyat güncelleme
  const handlePriceUpdate = (priceUpdates) => {
    updateMenuPrices(priceUpdates);
    // Global kaydet (Firebase varsa global, yoksa localStorage)
    savePrices(priceUpdates);
  };

  // Scroll spy için kategori takibi - throttled ve optimized
  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (Date.now() < suppressSpyUntil) {
            ticking = false;
            return;
          }
          
          const sections = restaurantData.categories.map(cat => ({
            id: cat.id,
            element: document.getElementById(cat.id)
          })).filter(section => section.element);

          const currentSection = sections.find(section => {
            const rect = section.element.getBoundingClientRect();
            return rect.top <= 200 && rect.bottom >= 200;
          });

          if (currentSection && currentSection.id !== activeCategory) {
            setActiveCategory(currentSection.id);
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    // Passive scroll listener for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll, { passive: true });
  }, [activeCategory, suppressSpyUntil]);

  // Welcome Screen'den menüye geçiş
  const handleEnterMenu = () => {
    setShowWelcome(false);
  };

  return (
    <>
      <GlobalStyles />
      <div className="App">
        {showWelcome ? (
          <WelcomeScreen 
            restaurantName={restaurantData.name}
            onEnter={handleEnterMenu}
          />
        ) : (
          <>
            <Header 
              restaurant={menuData}
            />
            
            <CategoryNavigation
              categories={menuData.categories}
              activeCategory={activeCategory}
              onCategoryChange={(catId) => {
                setSuppressSpyUntil(Date.now() + 1000);
                setActiveCategory(catId);
                // Güvenlik için bastan 1200ms sonra da kapat
                setTimeout(() => setSuppressSpyUntil(0), 1200);
              }}
            />
            
            <Container>
              <main style={{ paddingTop: '2rem', paddingBottom: '3rem' }}>
                {menuData.categories.map((category) => (
                  <MenuCategory key={category.id} category={category} />
                ))}
              </main>
            </Container>
            
            <AdminPanel
              isVisible={showAdmin}
              onClose={() => setShowAdmin(false)}
              menuData={menuData}
              onPriceUpdate={handlePriceUpdate}
            />
          </>
        )}
      </div>
    </>
  );
}

export default App;
